<div class="flex justify-end items-center gap-2">
  <!-- Botón para ejecutar una acción en masa -->
  <button
    *ngFor="let action of bulkActions"
    (click)="executeBulkAction(action)"
    class="bg-primary text-lightGray2 py-2 rounded-full hover:bg-opacity-90 hover:shadow-md duration-300 px-5">
    {{ action.label }}
  </button>
</div>
